<div class="progress-wrapper" *ngIf="stage" [ngClass]="{'completed': stage?.ID === 'SBMT', 'cancel': state?.ID === 'CCD', 'delay': state?.ID === 'RDL'}">
  <div class="completed-text" *ngIf="stage?.ID === 'SBMT' && state?.ID !== 'CCD'">Completed</div>
  <div class="cancel-text" *ngIf="state?.ID === 'CCD'">Canceled</div>
  <div class="cancel-text right" *ngIf="state?.ID === 'RDL'">
    {{delay?.DELAY_TYPE === delayType.CLIENT ? 'Client Delay' : 'Reliant Delay'}}
  </div>
  <div class="stage hinted" *ngFor="let s of stages | orderBy : ['ORDER']"
       [ngClass]="{'completed' : (stage.ORDER > s.ORDER), 'current' : (stage.ORDER === s.ORDER)}">
    <div class="hint">{{s.NAME}}</div>
  </div>
</div>
